<app-modal [table]="true" (modalClose)="closeModal()">
    <div class="table">
        <h4 class="table__eyebrow">Table 6</h4>
        <h2 class="table__title">Comparison of predictive CART models, with and without pancreatic imaging</h2>
        <div class="table-wrapper">
            <ul class="model-column">
                <li class="short"></li>
                <li class="short">Predictive model</li>
                <li class="medium cart">CART (49 variables)</li>
                <li class="tall cart">CART (42 variables – no imaging)</li>
            </ul>
            <div class="scroll">
                <ul class="row">
                    <li class="short type">Full</li>
                    <li class="short type">5-fold-cross-validation</li>
                </ul>
                <ul class="row">
                    <li class="short full-cat">mRate</li>
                    <li class="short full-cat">AUC</li>
                    <li class="short cross-cat">average mRate</li>
                    <li class="short cross-cat">AUC</li>
                </ul>
                <ul class="row">
                    <li class="medium full-data">0.15</li>
                    <li class="medium full-data">0.89</li>
                    <li class="medium cross-data">0.31</li>
                    <li class="medium cross-data">0.68</li>
                </ul>
                <ul class="row">
                    <li class="tall full-data">0.19</li>
                    <li class="tall full-data">0.85</li>
                    <li class="tall cross-data">0.34</li>
                    <li class="tall cross-data">0.70</li>
                </ul>
            </div>
        </div>
        <!-- Disclaimer -->
        <div class="table__disclaimer">
            <p>mRate = training error rate; average mRate = prediction error rate.</p>
            <p>AUC, area under the curve; CART, Classification and Regression Tree.</p>
        </div>
    </div>
</app-modal>